/**
 * TanStack Query hooks for `guided-onboarding`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	guidedOnboardingQueryKeys,
	type CreateGuidedOnboardingBody,
	type ListGuidedOnboardingResponse,
	type GuidedOnboardingRow,
} from "./api";

export function useGuidedOnboardingList(): UseQueryResult<ListGuidedOnboardingResponse, Error> {
	return useQuery({
		queryKey: guidedOnboardingQueryKeys.list(),
		queryFn: list,
	});
}

export function useGuidedOnboardingCreate(): UseMutationResult<GuidedOnboardingRow, Error, CreateGuidedOnboardingBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: guidedOnboardingQueryKeys.all });
		},
	});
}

export function useGuidedOnboardingDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: guidedOnboardingQueryKeys.all });
		},
	});
}
